@let user = userProfile();
@let settings = selectSelectedUserSettings();
@if (user && settings) {
  @if (viewport.isMobile()) {
    <ng-container *ngTemplateOutlet="mobileLayout"></ng-container>
  } @else {
    <ng-container *ngTemplateOutlet="desktopLayout"></ng-container>
  }
}

<ng-template #mobileLayout>
  @let user = userProfile();
  @let settings = selectSelectedUserSettings();
  @if (user && settings) {
    <div class="mobile-page">
      <div class="mobile-row" uiTouchFeedback (click)="openSheet('name')">
        <span class="mobile-row-icon ui-icon-user"></span>
        <div class="mobile-row-body">
          <div class="mobile-row-label">
            {{ 'SUAS.ACCOUNT.DETAILS.FULL_NAME' | translate }}
          </div>
          <div class="mobile-row-value" style="text-transform: capitalize">
            {{ user.firstname }} {{ user.lastname }}
          </div>
        </div>
        @if (enableActions) {
          <span class="mobile-row-chevron">›</span>
        }
      </div>

      <div class="mobile-row" uiTouchFeedback (click)="openSheet('email')">
        <span class="mobile-row-icon ui-icon-mail"></span>
        <div class="mobile-row-body">
          <div class="mobile-row-label">
            {{ 'SUAS.ACCOUNT.DETAILS.EMAIL' | translate }}
          </div>
          <div class="mobile-row-value">{{ user.email }}</div>
        </div>
        @if (enableActions) {
          <span class="mobile-row-chevron">›</span>
        }
      </div>

      <div class="mobile-row" uiTouchFeedback (click)="openSheet('phone')">
        <span class="mobile-row-icon ui-icon-phone"></span>
        <div class="mobile-row-body">
          <div class="mobile-row-label">
            {{ 'SUAS.ACCOUNT.DETAILS.PHONE' | translate }}
          </div>
          <div class="mobile-row-value">{{ user.phone }}</div>
        </div>
        @if (enableActions) {
          <span class="mobile-row-chevron">›</span>
        }
      </div>

      <div class="mobile-row" uiTouchFeedback (click)="openSheet('datetime')">
        <span class="mobile-row-icon ui-icon-calendar"></span>
        <div class="mobile-row-body">
          <div class="mobile-row-label">
            {{ 'SUAS.ACCOUNT.DETAILS.DATE_TIME' | translate }}
          </div>
          <div class="mobile-row-value">
            {{ dateTimeFormatMap[settings.dateFormat] }},
            {{ timeFormatMap[settings.hoursFormat] }},
            {{ user.timezone }}
          </div>
        </div>
        @if (enableActions) {
          <span class="mobile-row-chevron">›</span>
        }
      </div>

      <div class="mobile-row" uiTouchFeedback (click)="openSheet('language')">
        <span class="mobile-row-icon ui-icon-globe"></span>
        <div class="mobile-row-body">
          <div class="mobile-row-label">
            {{ 'SUAS.ACCOUNT.DETAILS.LANGUAGE' | translate }}
          </div>
          <div class="mobile-row-value">
            {{ langString[settings.lang] }}
          </div>
        </div>
        @if (enableActions) {
          <span class="mobile-row-chevron">›</span>
        }
      </div>

      <div class="mobile-row" uiTouchFeedback (click)="openSheet('theme')">
        <span class="mobile-row-icon ui-icon-preferences"></span>
        <div class="mobile-row-body">
          <div class="mobile-row-label">
            {{ 'SUAS.ACCOUNT.DETAILS.THEME' | translate }}
          </div>
          <div class="mobile-row-value">
            {{ themeString[settings.theme] }}
          </div>
        </div>
        @if (enableActions) {
          <span class="mobile-row-chevron">›</span>
        }
      </div>

      @if (isVisible(Setting.WEEKLY_EMAILS)) {
        <div class="mobile-row" uiTouchFeedback (click)="openSheet('weekly')">
          <span class="mobile-row-icon ui-icon-mail"></span>
          <div class="mobile-row-body">
            <div class="mobile-row-label">
              {{ 'SUAS.ACCOUNT.DETAILS.WEEKLY_EMAILS' | translate }}
            </div>
            <div class="mobile-row-value">
              {{
                (settings?.subForWeekly ?? true)
                  ? ('SUAS.COMMON.ENABLED' | translate)
                  : ('SUAS.ACCOUNT.DETAILS.DISABLED' | translate)
              }}
            </div>
          </div>
          @if (enableActions) {
            <span class="mobile-row-chevron">›</span>
          }
        </div>
      }

      @if (isVisible(Setting.DEVICE_PAGE_VIEW)) {
        <div class="mobile-row" uiTouchFeedback (click)="openSheet('device')">
          <span class="mobile-row-icon ui-icon-camera"></span>
          <div class="mobile-row-body">
            <div class="mobile-row-label">
              {{ 'SUAS.ACCOUNT.DETAILS.DEVICE_PAGE_VIEW' | translate }}
            </div>
            <div class="mobile-row-value">
              {{
                (settings?.newDevicePageView ?? true)
                  ? ('SUAS.ACCOUNT.DETAILS.NEW' | translate)
                  : ('SUAS.ACCOUNT.DETAILS.OLD' | translate)
              }}
            </div>
          </div>
          @if (enableActions) {
            <span class="mobile-row-chevron">›</span>
          }
        </div>
      }

      @if (isVisible(Setting.DEVICE_EMAILS)) {
        <div
          class="mobile-row"
          uiTouchFeedback
          (click)="changeDeviceEmailsModal()"
        >
          <span class="mobile-row-icon ui-icon-mail"></span>
          <div class="mobile-row-body">
            <div class="mobile-row-label">
              {{ 'SUAS.ACCOUNT.DETAILS.DEVICE_EMAILS.TITLE' | translate }}
            </div>
            <div class="mobile-row-value">{{ deviceEmailsSummary() }}</div>
          </div>
          @if (enableActions) {
            <span class="mobile-row-chevron">›</span>
          }
        </div>
      }

      @if (isVisible(Setting.GLOBAL_SEARCH)) {
        <div class="mobile-row" uiTouchFeedback (click)="openSheet('search')">
          <span class="mobile-row-icon ui-icon-search"></span>
          <div class="mobile-row-body">
            <div class="mobile-row-label">
              {{ 'SUAS.ACCOUNT.DETAILS.GLOBAL_SEARCH_SETTINGS' | translate }}
            </div>
            <div class="mobile-row-value">
              {{ 'SUAS.ACCOUNT.GLOBAL_SEARCH_SETTINGS.LAST_SYNCED_AT' | translate }}
              {{ options?.lastSyncedAt | date: 'dd-MM-YY HH:mm:ss' }}
            </div>
          </div>
          @if (enableActions) {
            <span class="mobile-row-chevron">›</span>
          }
        </div>
      }

      <div class="mobile-row" uiTouchFeedback (click)="openSheet('logout')">
        <span class="mobile-row-icon ui-icon-logout"></span>
        <div class="mobile-row-body">
          <div class="mobile-row-label">
            {{ 'SUAS.ACCOUNT.DETAILS.AUTO_LOGOUT' | translate }}
          </div>
          <div class="mobile-row-value">
            @if (settings.autoLogoutEnabled) {
              {{ settings.autoLogout }}
              {{ 'SUAS.CALENDAR.MINUTES' | translate }}
            } @else {
              {{ 'SUAS.ACCOUNT.DETAILS.DISABLED' | translate }}
            }
          </div>
        </div>
        @if (enableActions) {
          <span class="mobile-row-chevron">›</span>
        }
      </div>
    </div>

    <ui-bottom-sheet
      [open]="activeSheet() === 'name'"
      [title]="'SUAS.ACCOUNT.DETAILS.FULL_NAME' | translate"
      (closeEmit)="closeSheet()"
    >
      <div sheet-content class="sheet-form">
        <div class="flex-col gap-8">
          <label class="sheet-field-label">{{
            'SUAS.ACCOUNT.DETAILS.FULL_NAME' | translate
          }}</label>
          <input
            class="ui-input ui-input-40 w-100"
            [formControl]="nameControl"
          />
        </div>
      </div>
      <div sheet-actions class="w-100">
        <ui-button
          class="w-100"
          [text]="'SUAS.COMMON.SAVE' | translate"
          type="primary"
          size="l"
          (clickAction)="saveName()"
        />
      </div>
    </ui-bottom-sheet>

    <ui-bottom-sheet
      [open]="activeSheet() === 'email'"
      [title]="'SUAS.ACCOUNT.DETAILS.EMAIL' | translate"
      (closeEmit)="closeSheet()"
    >
      <div sheet-content class="sheet-form">
        <div class="flex-col gap-8">
          <label class="sheet-field-label">{{
            'SUAS.ACCOUNT.DETAILS.NEW_EMAIL' | translate
          }}</label>
          <input
            class="ui-input ui-input-40 w-100"
            type="email"
            [formControl]="emailControl"
          />
        </div>
        @if (verifyCodeSentId()) {
          <div class="flex-col gap-8">
            <label class="sheet-field-label">{{
              'SUAS.ACCOUNT.DETAILS.CONFIRMATION_CODE' | translate
            }}</label>
            <input
              class="ui-input ui-input-40 w-100"
              type="text"
              [formControl]="confirmationCodeControl"
            />
            <a
              class="sheet-resend-link"
              [class.disabled]="!!verifyResendTimer()"
              (click)="verifyResendTimer() ? null : sendEmailCode()"
            >
              {{ 'SUAS.ACCOUNT.DETAILS.RESEND_MSG' | translate }}
              @if (verifyResendTimer()) {
                (00:{{ verifyResendTimer() < 10 ? '0' : ''
                }}{{ verifyResendTimer() }})
              }
            </a>
          </div>
        }
      </div>
      <div sheet-actions class="w-100">
        @if (!verifyCodeSentId()) {
          <ui-button
            class="w-100"
            [text]="'SUAS.ACCOUNT.DETAILS.GET_CODE' | translate"
            type="primary"
            size="l"
            [disabled]="emailControl.invalid"
            [loading]="isSaving()"
            (clickAction)="sendEmailCode()"
          />
        } @else {
          <ui-button
            class="w-100"
            [text]="'SUAS.COMMON.SEND' | translate"
            type="primary"
            size="l"
            [disabled]="confirmationCodeControl.invalid"
            [loading]="isSaving()"
            (clickAction)="confirmCode()"
          />
        }
      </div>
    </ui-bottom-sheet>

    <ui-bottom-sheet
      [open]="activeSheet() === 'phone'"
      [title]="'SUAS.ACCOUNT.DETAILS.PHONE' | translate"
      (closeEmit)="closeSheet()"
    >
      <div sheet-content class="sheet-form">
        <div class="flex-col gap-8">
          <label class="sheet-field-label">{{
            'SUAS.ACCOUNT.DETAILS.PHONE' | translate
          }}</label>
          <ui-phone-input-v2
            class="w-100"
            [formControl]="phoneControl"
          ></ui-phone-input-v2>
        </div>
        @if (verifyCodeSentId()) {
          <div class="flex-col gap-8">
            <label class="sheet-field-label">{{
              'SUAS.ACCOUNT.DETAILS.CONFIRMATION_CODE' | translate
            }}</label>
            <input
              class="ui-input ui-input-40 w-100"
              type="text"
              [formControl]="confirmationCodeControl"
            />
            <a
              class="sheet-resend-link"
              [class.disabled]="!!verifyResendTimer()"
              (click)="verifyResendTimer() ? null : sendPhoneCode()"
            >
              {{ 'SUAS.ACCOUNT.DETAILS.RESEND_MSG' | translate }}
              @if (verifyResendTimer()) {
                (00:{{ verifyResendTimer() < 10 ? '0' : ''
                }}{{ verifyResendTimer() }})
              }
            </a>
          </div>
        }
      </div>
      <div sheet-actions class="w-100">
        @if (!verifyCodeSentId()) {
          <ui-button
            class="w-100"
            [text]="'SUAS.ACCOUNT.DETAILS.GET_CODE' | translate"
            type="primary"
            size="l"
            [disabled]="phoneControl.invalid"
            [loading]="isSaving()"
            (clickAction)="sendPhoneCode()"
          />
        } @else {
          <ui-button
            class="w-100"
            [text]="'SUAS.COMMON.SEND' | translate"
            type="primary"
            size="l"
            [disabled]="confirmationCodeControl.invalid"
            [loading]="isSaving()"
            (clickAction)="confirmCode()"
          />
        }
      </div>
    </ui-bottom-sheet>

    <ui-bottom-sheet
      [open]="activeSheet() === 'language'"
      [title]="'SUAS.ACCOUNT.DETAILS.LANGUAGE' | translate"
      (closeEmit)="closeSheet()"
    >
      <div sheet-content class="sheet-options-list">
        @for (lang of languages; track lang.value) {
          <div
            class="sheet-option"
            (click)="languageControl.setValue(lang.value)"
          >
            <div
              class="custom-radio"
              [class.checked]="languageControl.value === lang.value"
            ></div>
            <span
              class="option-label"
              [class.selected]="languageControl.value === lang.value"
              >{{ lang.label }}</span
            >
          </div>
        }
      </div>
      <div sheet-actions class="w-100">
        <ui-button
          class="w-100"
          [text]="'SUAS.COMMON.SAVE' | translate"
          type="primary"
          size="l"
          (clickAction)="saveLanguage()"
        />
      </div>
    </ui-bottom-sheet>

    <ui-bottom-sheet
      [open]="activeSheet() === 'theme'"
      [title]="'SUAS.ACCOUNT.DETAILS.THEME' | translate"
      (closeEmit)="closeSheet()"
    >
      <div sheet-content class="sheet-options-list">
        @for (t of themes; track t.value) {
          <div class="sheet-option" (click)="themeControl.setValue(t.value)">
            <div
              class="custom-radio"
              [class.checked]="themeControl.value === t.value"
            ></div>
            <span
              class="option-label"
              [class.selected]="themeControl.value === t.value"
              >{{ t.label }}</span
            >
          </div>
        }
      </div>
      <div sheet-actions class="w-100">
        <ui-button
          class="w-100"
          [text]="'SUAS.COMMON.SAVE' | translate"
          type="primary"
          size="l"
          (clickAction)="saveTheme()"
        />
      </div>
    </ui-bottom-sheet>

    @if (isVisible(Setting.DEVICE_PAGE_VIEW)) {
      <ui-bottom-sheet
        [open]="activeSheet() === 'device'"
        [title]="'SUAS.ACCOUNT.DETAILS.DEVICE_PAGE_VIEW' | translate"
        (closeEmit)="closeSheet()"
      >
        <div sheet-content class="sheet-options-list">
          <div
            class="sheet-option"
            (click)="devicePageViewControl.setValue(true)"
          >
            <div
              class="custom-radio"
              [class.checked]="devicePageViewControl.value === true"
            ></div>
            <span
              class="option-label"
              [class.selected]="devicePageViewControl.value === true"
              >{{ 'SUAS.ACCOUNT.DETAILS.NEW' | translate }}</span
            >
          </div>
          <div
            class="sheet-option"
            (click)="devicePageViewControl.setValue(false)"
          >
            <div
              class="custom-radio"
              [class.checked]="devicePageViewControl.value === false"
            ></div>
            <span
              class="option-label"
              [class.selected]="devicePageViewControl.value === false"
              >{{ 'SUAS.ACCOUNT.DETAILS.OLD' | translate }}</span
            >
          </div>
        </div>
        <div sheet-actions class="w-100">
          <ui-button
            class="w-100"
            [text]="'SUAS.COMMON.SAVE' | translate"
            type="primary"
            size="l"
            (clickAction)="saveDevicePageView()"
          />
        </div>
      </ui-bottom-sheet>
    }

    <ui-bottom-sheet
      [open]="activeSheet() === 'datetime'"
      [title]="'SUAS.ACCOUNT.DETAILS.DATE_TIME' | translate"
      (closeEmit)="closeSheet()"
    >
      <div sheet-content class="sheet-form" [formGroup]="dateTimeForm">
        <div class="flex-col gap-8">
          <label class="sheet-field-label">{{
            'SUAS.ACCOUNT.DETAILS.DATE_FORMAT' | translate
          }}</label>
          <mat-select
            class="ui-selector ui-selector-40"
            formControlName="dateFormat"
          >
            @for (fmt of dateFormatOptions; track fmt.value) {
              <mat-option [value]="fmt.value">{{ fmt.name }}</mat-option>
            }
          </mat-select>
        </div>
        <div class="flex-col gap-8">
          <label class="sheet-field-label">{{
            'SUAS.ACCOUNT.DETAILS.HOUR_FORMAT' | translate
          }}</label>
          <mat-radio-group class="flex-row gap-4" formControlName="hoursFormat">
            <mat-radio-button color="primary" [value]="hourFormatEnum.hours12">
              {{ 'SUAS.ACCOUNT.DETAILS.12HOURS' | translate }}
            </mat-radio-button>
            <mat-radio-button color="primary" [value]="hourFormatEnum.hours24">
              {{ 'SUAS.ACCOUNT.DETAILS.24HOURS' | translate }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="flex-col gap-8">
          <label class="sheet-field-label">{{
            'SUAS.ACCOUNT.DETAILS.TIMEZONE' | translate
          }}</label>
          <mat-select
            class="ui-selector ui-selector-40"
            formControlName="timezone"
          >
            @for (zone of timeZones; track zone) {
              <mat-option [value]="zone">{{ zone }}</mat-option>
            }
          </mat-select>
        </div>
      </div>
      <div sheet-actions class="w-100">
        <ui-button
          class="w-100"
          [text]="'SUAS.COMMON.SAVE' | translate"
          type="primary"
          size="l"
          (clickAction)="saveDateTime()"
        />
      </div>
    </ui-bottom-sheet>

    @if (isVisible(Setting.WEEKLY_EMAILS)) {
      <ui-bottom-sheet
        [open]="activeSheet() === 'weekly'"
        [title]="'SUAS.ACCOUNT.DETAILS.WEEKLY_EMAILS' | translate"
        (closeEmit)="closeSheet()"
      >
        <div sheet-content class="sheet-form">
          <div class="flex-row start-center gap-12">
            <ui-toggle [formControl]="weeklyControl"></ui-toggle>
            <span>{{
              'SUAS.ACCOUNT.DETAILS.WEEKLY_EMAILS_ENABLE' | translate
            }}</span>
          </div>
          <div class="sheet-field-description">
            {{ 'SUAS.ACCOUNT.DETAILS.WEEKLY_EMAILS_DESC' | translate }}
          </div>
        </div>
        <div sheet-actions class="w-100">
          <ui-button
            class="w-100"
            [text]="'SUAS.COMMON.SAVE' | translate"
            type="primary"
            size="l"
            (clickAction)="saveWeekly()"
          />
        </div>
      </ui-bottom-sheet>
    }

    <ui-bottom-sheet
      [open]="activeSheet() === 'logout'"
      [title]="'SUAS.ACCOUNT.DETAILS.AUTO_LOGOUT' | translate"
      (closeEmit)="closeSheet()"
    >
      <div sheet-content class="sheet-form" [formGroup]="autoLogoutForm">
        <div class="flex-row start-center gap-12">
          <ui-toggle formControlName="enabled"></ui-toggle>
          <label>{{ 'SUAS.ACCOUNT.DETAILS.AUTO_LOGOUT' | translate }}</label>
        </div>
        <div class="flex-col gap-8">
          <label class="sheet-field-label">{{
            'SUAS.ACCOUNT.DETAILS.MIN' | translate
          }}</label>
          <input
            class="ui-input ui-input-40 w-100"
            type="number"
            formControlName="minutes"
            placeholder="60"
            [class.disabled]="!autoLogoutForm.get('enabled')?.value"
          />
        </div>
      </div>
      <div sheet-actions class="w-100">
        <ui-button
          class="w-100"
          [text]="'SUAS.COMMON.SAVE' | translate"
          type="primary"
          size="l"
          (clickAction)="saveAutoLogout()"
        />
      </div>
    </ui-bottom-sheet>

    @if (isVisible(Setting.GLOBAL_SEARCH)) {
      <ui-bottom-sheet
        [open]="activeSheet() === 'search'"
        [title]="'SUAS.ACCOUNT.DETAILS.GLOBAL_SEARCH_SETTINGS' | translate"
        (closeEmit)="closeSheet()"
      >
        <div sheet-content class="sheet-form" [formGroup]="searchForm">
          <div class="flex-row start-center gap-12">
            <ui-toggle formControlName="markResult"></ui-toggle>
            <span>{{ 'GLOBAL_SEARCH_SETTINGS.MARK_RESULT' | translate }}</span>
          </div>
          <div class="flex-row start-center gap-12">
            <ui-toggle formControlName="includeAllMatch"></ui-toggle>
            <span>{{
              'GLOBAL_SEARCH_SETTINGS.INCLUDE_ALL_MATCH' | translate
            }}</span>
          </div>
        </div>
        <div sheet-actions class="w-100">
          <ui-button
            class="w-100"
            [text]="'SUAS.COMMON.SAVE' | translate"
            type="primary"
            size="l"
            (clickAction)="saveGlobalSearch()"
          />
        </div>
      </ui-bottom-sheet>
    }
  }
</ng-template>

<ng-template #desktopLayout>
  @let user = userProfile();
  @let settings = selectSelectedUserSettings();
  @if (user && settings) {
    <div class="ui-level2-page-wrapper h-100">
      <div class="ui-level2-page h-100">
        <div class="flex-col gap-16">
          <div class="flex-row space-between-center section">
            <div class="flex-row start-center gap-16">
              <div class="flex-row gap-8">
                <span class="icon ui-icon-user"></span>
                <span class="label">{{
                  'SUAS.ACCOUNT.DETAILS.FULL_NAME' | translate
                }}</span>
              </div>
              <span class="value" style="text-transform: capitalize"
                >{{ user.firstname }} {{ user.lastname }}</span
              >
            </div>
            @if (enableActions) {
              <span
                class="ui-icon-edit icon-hover"
                (click)="changeUsernameModal()"
              ></span>
            }
          </div>
          <div class="flex-row space-between-center section">
            <div class="flex-row start-center gap-16">
              <div class="flex-row gap-8">
                <span class="icon ui-icon-mail"></span>
                <span class="label">{{
                  'SUAS.ACCOUNT.DETAILS.EMAIL' | translate
                }}</span>
              </div>
              <span class="value">{{ user.email }}</span>
            </div>
            @if (enableActions) {
              <span
                class="ui-icon-edit icon-hover"
                (click)="changeEmailModal()"
              ></span>
            }
          </div>
          <div class="flex-row space-between-center section">
            <div class="flex-row start-center gap-16">
              <div class="flex-row gap-8">
                <span class="icon ui-icon-phone"></span>
                <span class="label">{{
                  'SUAS.ACCOUNT.DETAILS.PHONE' | translate
                }}</span>
              </div>
              <span class="value">{{ user.phone }}</span>
            </div>
            @if (enableActions) {
              <span
                class="ui-icon-edit icon-hover"
                (click)="changePhoneModal()"
              ></span>
            }
          </div>
          <div class="flex-row space-between-center section">
            <div class="flex-row start-center gap-16">
              <div class="flex-row gap-8">
                <span class="icon ui-icon-calendar"></span>
                <span class="label">{{
                  'SUAS.ACCOUNT.DETAILS.DATE_TIME' | translate
                }}</span>
              </div>
              <span class="value"
                >{{ dateTimeFormatMap[settings.dateFormat] }} ,
                {{ timeFormatMap[settings.hoursFormat] }},
                {{ user.timezone }}</span
              >
            </div>
            @if (enableActions) {
              <span
                class="ui-icon-edit icon-hover"
                (click)="changeUserDateSettingsModal()"
              ></span>
            }
          </div>
          <div class="flex-row space-between-center section">
            <div class="flex-row start-center gap-16">
              <div class="flex-row gap-8">
                <span class="icon ui-icon-globe"></span>
                <span class="label">{{
                  'SUAS.ACCOUNT.DETAILS.LANGUAGE' | translate
                }}</span>
              </div>
              <span class="value">{{ langString[settings.lang] }}</span>
            </div>
            @if (enableActions) {
              <span
                class="ui-icon-edit icon-hover"
                (click)="changeUserLanguageModal()"
              ></span>
            }
          </div>
          <div class="flex-row space-between-center section">
            <div class="flex-row start-center gap-16">
              <div class="flex-row center-center gap-8">
                <span class="icon ui-icon-preferences"></span>
                <span class="label">{{
                  'SUAS.ACCOUNT.DETAILS.THEME' | translate
                }}</span>
              </div>
              <span class="value">{{ themeString[settings.theme] }}</span>
            </div>
            @if (enableActions) {
              <span
                class="ui-icon-edit icon-hover"
                (click)="changeUserThemeModal()"
              ></span>
            }
          </div>
          @if (isVisible(Setting.WEEKLY_EMAILS)) {
            <div class="flex-row space-between-center section">
              <div class="flex-row start-center gap-16">
                <div class="flex-row center-center gap-8">
                  <span class="icon ui-icon-mail"></span>
                  <span class="label">{{
                    'SUAS.ACCOUNT.DETAILS.WEEKLY_EMAILS' | translate
                  }}</span>
                </div>
                <span class="value">{{
                  (settings?.subForWeekly ?? true)
                    ? ('SUAS.COMMON.ENABLED' | translate)
                    : ('SUAS.ACCOUNT.DETAILS.DISABLED' | translate)
                }}</span>
              </div>
              @if (enableActions) {
                <span
                  class="ui-icon-edit icon-hover"
                  (click)="changeWeeklySubscriptionModal()"
                ></span>
              }
            </div>
          }
          @if (isVisible(Setting.DEVICE_PAGE_VIEW)) {
            <div class="flex-row space-between-center section">
              <div class="flex-row start-center gap-16">
                <div class="flex-row center-center gap-8">
                  <span class="icon ui-icon-camera"></span>
                  <span class="label">{{
                    'SUAS.ACCOUNT.DETAILS.DEVICE_PAGE_VIEW' | translate
                  }}</span>
                </div>
                <span class="value">{{
                  (settings?.newDevicePageView ?? true)
                    ? ('SUAS.ACCOUNT.DETAILS.NEW' | translate)
                    : ('SUAS.ACCOUNT.DETAILS.OLD' | translate)
                }}</span>
              </div>
              @if (enableActions) {
                <span
                  class="ui-icon-edit icon-hover"
                  (click)="changeDevicePageViewDialog()"
                ></span>
              }
            </div>
          }
          @if (isVisible(Setting.DEVICE_EMAILS)) {
            <div
              class="flex-row space-between-center section device-emails-section"
            >
              <div class="flex-row start-center gap-16">
                <div class="flex-row center-center gap-8">
                  <span class="icon ui-icon-mail"></span>
                  <span class="label">{{
                    'SUAS.ACCOUNT.DETAILS.DEVICE_EMAILS.TITLE' | translate
                  }}</span>
                </div>
                <span class="value">{{ deviceEmailsSummary() }}</span>
              </div>
              @if (enableActions) {
                <span
                  class="ui-icon-edit icon-hover"
                  (click)="changeDeviceEmailsModal()"
                ></span>
              }
            </div>
          }
          @if (isVisible(Setting.GLOBAL_SEARCH)) {
            <div class="flex-row space-between-center section">
              <div class="flex-row start-center gap-16">
                <div class="flex-row center-center gap-8">
                  <span class="icon ui-icon-search"></span>
                  <span class="label">{{
                    'SUAS.ACCOUNT.DETAILS.GLOBAL_SEARCH_SETTINGS' | translate
                  }}</span>
                  <small
                    >{{
                      'SUAS.ACCOUNT.GLOBAL_SEARCH_SETTINGS.LAST_SYNCED_AT'
                        | translate
                    }}
                    {{ options?.lastSyncedAt | date: 'dd-MM-YY HH:mm:ss' }}
                  </small>
                  <span
                    class="ui-icon-forward c-p"
                    (click)="sync()"
                    [matTooltip]="
                      'SUAS.ACCOUNT.GLOBAL_SEARCH_SETTINGS.TOOLTIPS.SYNC' | translate
                    "
                  ></span>
                </div>
              </div>
              @if (enableActions) {
                <span
                  class="ui-icon-edit icon-hover"
                  (click)="changeGlobalSearchSettingsDialog()"
                ></span>
              }
            </div>
          }
          <div class="flex-row space-between-center section">
            <div class="flex-row start-center gap-16">
              <div class="flex-row gap-8">
                <span class="icon ui-icon-logout"></span>
                <span class="label">{{
                  'SUAS.ACCOUNT.DETAILS.AUTO_LOGOUT' | translate
                }}</span>
              </div>
              <span *ngIf="settings.autoLogoutEnabled" class="value"
                >{{ settings.autoLogout }}
                {{ 'SUAS.CALENDAR.MINUTES' | translate }}</span
              >
              <span *ngIf="!settings.autoLogoutEnabled" class="value">{{
                'SUAS.ACCOUNT.DETAILS.DISABLED' | translate
              }}</span>
            </div>
            @if (enableActions) {
              <span
                class="ui-icon-edit icon-hover"
                (click)="changeAutoLogoutModal()"
              ></span>
            }
          </div>
        </div>
        <div class="flex-row space-between-center mt-16 w-100">
          <div></div>
          <div class="version-label">
            {{ 'SUAS.ACCOUNT.DETAILS.VERSION' | translate: { version } }}
          </div>
        </div>
      </div>
    </div>
  }
</ng-template>
